import {  printError } from '../helpers/index.js';

import Swal from 'sweetalert2';
class WebsiteService {

  

  async getGeography()
  {
    console.log("getGeography");
    const getResponse = await fetch("/api/geography")
    .then( (data) => data.json() )
    .catch( (error) => error );
    return this.fetchResponse(getResponse);
  }
/*
  async getClients(active = true)
  {
    console.log("getClients");
    const getResponse = await fetch("/api/clients?" + new URLSearchParams({
        active: active
      }).toString())
    .then( (data) => data.json() )
    .catch( (error) => error );
    return this.fetchResponse(getResponse);
  }
*/
  async getProducts(active = true)
  {
    console.log("getProducts");
    const getResponse = await fetch("/api/products")
    .then( (data) => data.json() )
    .catch( (error) => error );
    return this.fetchResponse(getResponse);
  }

  async getColors(active = true)
  {
    console.log("getColors");
    const getResponse = await fetch("/api/colors")
    .then( (data) => data.json() )
    .catch( (error) => error );
    return this.fetchResponse(getResponse);
  }

  async getParcels(active = true)
  {
    console.log("getParcels");
    const getResponse = await fetch("/api/parcels")
    .then( (data) => data.json() )
    .catch( (error) => error );
    return this.fetchResponse(getResponse);
  }

  async getLocations(active = true)
  {
    console.log("getLocations");
    const getResponse = await fetch("/api/locations")
    .then( (data) => data.json() )
    .catch( (error) => error );
    return this.fetchResponse(getResponse);
  }

  async getPriceLists(active = true)
  {
    console.log("getPriceLists");
    const getResponse = await fetch("/api/pricelists")
    .then( (data) => data.json() )
    .catch( (error) => error );
    return this.fetchResponse(getResponse);
  }

  async getTieredPricing(active = true) {
    console.log("getTieredPricing");

    const getResponse = await fetch("/api/tieredpricing")
      .then((res) => res.json())
      .catch((error) => {
        console.error("Error fetching tiered pricing:", error);
        return [];
      });

    console.log("Tiered pricing data received:", getResponse);
    return getResponse; 
  }

  async getNeighborhoods( cityId )
  {
    const getResponse = await fetch("/api/cities?" + new URLSearchParams({
        cityId: cityId
      }).toString())
    .then( (data) => data.json() )
    .catch( (error) => error )
    return this.fetchResponse(getResponse);
  }

  async getCheckinsByStatus(opts = {}) {
    const params = new URLSearchParams({ by_status: 'true' });
    if (opts.site) {
   params.append('site', String(opts.site));
    }
 const url = `/api/checkin?${params.toString()}`;
 const getResponse = await fetch(url)
   .then((data) => data.json())
 .catch((error) => error);
    return this.fetchResponse(getResponse, false);
  }

  async getCheckins(date, dateEnd, site) {
    console.log('getCheckins', date, dateEnd, site);

    const params = new URLSearchParams();
    const start =
      date.getFullYear() + '-' +
      (date.getMonth() > 8 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)) + '-' +
      (date.getDate() > 9 ? date.getDate() : '0' + date.getDate());

    params.append('date', start);
    if (dateEnd) {
      const end =
        dateEnd.getFullYear() + '-' +
        (dateEnd.getMonth() > 8 ? (dateEnd.getMonth() + 1) : '0' + (dateEnd.getMonth() + 1)) + '-' +
        (dateEnd.getDate() > 9 ? dateEnd.getDate() : '0' + dateEnd.getDate());

      params.append('end_date', end);
    }
    if (site) {
      params.append('site', String(site));
    }

    const url = `/api/checkin?${params.toString()}`;

    const getResponse = await fetch(url)
      .then((data) => data.json())
      .catch((error) => error);

    return this.fetchResponse(getResponse);
  }

  async getCheckinTotals(site) {
    const params = new URLSearchParams();
    if (site) {
      params.append('site', String(site));
    }

    const qs  = params.toString();
    const url = `/api/checkin/total${qs ? `?${qs}` : ''}`;

    const getResponse = await fetch(url)
      .then((data) => data.json())
      .catch((error) => error);

    return this.fetchResponse(getResponse, false);
  }

  async changeCheckinStatus(data)
  {
    const getResponse = await fetch("/api/checkin/"+data.id, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then( (data) => data.json() )
    .catch( (error) => error )
    return this.fetchResponse(getResponse, false);
  }

  async getStatuses()
  {
    const getResponse = await fetch("/api/status")
    .then( (data) => data.json() )
    .catch( (error) => error )
    return this.fetchResponse(getResponse, false);
  }

 /* async getCheckinTotals()
  {
    const getResponse = await fetch("/api/checkin/total")
    .then( (data) => data.json() )
    .catch( (error) => error )
    return this.fetchResponse(getResponse, false);
  }* quitar funcion asincrona duplicada*/ 

  async getCancelReasons()
  {
    const getResponse = await fetch("/api/cancel_reason")
    .then( (data) => data.json() )
    .catch( (error) => error )
    return this.fetchResponse(getResponse, false);
  }

  async getEvents( data )
  {
    let dateParams = "";
    if ( data )
    {
      dateParams = new URLSearchParams(data).toString();
    }
    const getResponse = await fetch("/event?"+dateParams)
    .then( (data) => data.json() )
    .catch( (error) => error )
    return this.fetchResponse(getResponse);
  }

  async sendMail(email, salesOrderId)
  {
    const getResponse = await fetch("/api/sendmail?" + new URLSearchParams({
        email: email,
        id: salesOrderId
      }).toString()
    )
    .then( (data) => data.json() )
    .catch( (error) => error );
    return this.fetchResponse(getResponse);
  }

  fetchResponse(response, showError = true)
  {
    try
    {
      const result = response["result"][0]["data"];
      if ( response["result"][0]["status"].toLowerCase() === "error" )
      {
        if (showError)
        {
          printError(JSON.stringify(response), "Api Error: website fetch");
        }
      }
      return result;
    }
    catch ( error )
    {
      try {
        const result = response["read"][0]["data"];
        if ( response["read"][0]["status"].toLowerCase() === "error" )
        {
          if (showError)
          {
            printError(JSON.stringify(response), "Api Error: website fetch");
          }
        }
        return result;
      }
      catch (err)
      {
        console.log(err);
        if (showError)
        {
           Swal.fire({
                    title: "Reinicia la sesion!",
                    icon: "info"
                  });
        }
        return [];
      }
    }
  }

}

export { WebsiteService as default };
